<template>
  <div>
    <div>Details</div>
  </div>
</template>

<script>
export default {
  name: "HomeworkAnswer"
};
</script>

<style>
</style>